<shared-szczegoly-lokalizacji
  [pokazRokRemontu]="true"
  [czyDataRemontuWymagana]="this.czyDataRemontuWymagana"
  [opisWspoldzielonychParametrow]="'Określ szczegóły ogrodzenia'"
  [formularzLokalizacjiUszkodzenia]="formularzLokalizacjiUszkodzenia"
></shared-szczegoly-lokalizacji>

<app-step
  description="Co zostało uszkodzone?"
  [nextEnabled]="czyWprowadzoneUszkodzeniaSaPoprawne && czyFormularzLokalizacjiUszkodzeniaPoprawny()"
  nextLabel="ZAPISZ"
  (nextStepClicked)="zapiszUszkodzeniazPodformularzy()"
  (previousStepClicked)=this.navigation.back()>

  <div class="o-flex o-flex--grids mt-5">
    <div class="o-flex__item u-flex-5/12@desktop u-flex-1/1@small u-hidden@less-then-wide">
      <shared-selektor-lokalizacja
        [nazwaLokalizacji]="lokalizacjaUszkodzen.name"
      ></shared-selektor-lokalizacja>
    </div>

    <div class="o-flex__item u-flex-7/12@desktop u-flex-1/1@small align-self-stretch">
      <div class="c-card" style="height: auto; overflow: inherit">
        <shared-uszkodzenia-w-lokalizacji *ngFor="let uszkodzenie of listaDostepnychUszkodzen"
                                          [elementUszkodzenia]="uszkodzenie"
                                          [pokazSzerokosc]="uszkodzenie.atrybuty.pokazSzerokosc"
                                          [pokazWysokosc]="uszkodzenie.atrybuty.pokazWysokosc"
                                          [pokazWartosc]="uszkodzenie.atrybuty.pokazWartosc"
                                          [etykietaWartosci]="uszkodzenie.atrybuty.etykietaWartosci"
                                          [czyBrakObrazka]="true">
        </shared-uszkodzenia-w-lokalizacji>
      </div>
    </div>
  </div>
</app-step>
